import { render, staticRenderFns } from "./BtGenericAppSettings.vue?vue&type=template&id=2fea063f&scoped=true&"
import script from "./BtGenericAppSettings.vue?vue&type=script&lang=js&"
export * from "./BtGenericAppSettings.vue?vue&type=script&lang=js&"
import style0 from "./BtGenericAppSettings.vue?vue&type=style&index=0&id=2fea063f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea063f",
  null
  
)

export default component.exports